import React, { useContext, useEffect, useState } from 'react'
import './Home.css'
import { Vector } from './Vector'
import { ThemeContext } from '../../context'
import Navbar from '../Navbar'
import Sidebar from '../Sidebar'
import Banner from '../../assets/images/banner.png'

const Home = () => {
	const theme = useContext(ThemeContext)
	const darkMode = theme.state.darkMode
	const [width, setWidth] = useState(window.innerWidth)
	useEffect(() => {
		function handleResize() {
			setWidth(window.innerWidth)
		}
		window.addEventListener('resize', handleResize)
	}, [])
	return (
		<>
			{width < 700 ? <Sidebar /> : <Navbar />}

			<div className='wrapper' id='home'>
				<div className='left-box'>
					<div className='left-wrapper'>
						<h2 className='wrapper-intro' style={{ color: '#fff' && '#fff' }}>
							Hello there! 👋
						</h2>
						<h1
							className='wrapper-presentation'
							style={{ color: '#fff' && '#fff' }}>
							I am
						</h1>
						<div className='left-wrapper-title'>
							<div className='wrapper-name'>
								<div className='wrapper-name-item'>
									<span className='name-item-1'>Alejandro Rodríguez</span>
								</div>
								<div className='wrapper-name-item'>
									<span className='name-item-2'>FullStack Developer</span>
								</div>
							</div>
						</div>
						<div
							className='wrapper-description'
							style={{ color: '#fff' && '#fff' }}>
							I'm a full time geek. I am passionate about robotics, the development of technological products and programming. I'm always making something up.
						</div>
						<a href='#contact'>
							<button className='cta-btn'>Let's talk</button>
						</a>
					</div>
				</div>
				<div className='right-box'><img className='imgs' src={Banner} alt="" /></div>
			</div>
		</>
	)
}

export default Home
